import { Progress } from '@e2n/ui';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

export function AnlageassistentProgressbar() {
  const { ctx } = useAnlageassistentContext();

  return (
    <Progress
      value={ctx.currentStepProgress()}
      className="w-full h-2 rounded-none md:rounded-full"
    />
  );
}
